import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../baseQuery';
import { CustomerListItem, ChooseCustomerResponse, ChooseCustomerRequest } from './type';

export const customersApi = createApi({
  reducerPath: 'customersApi',
  tagTypes: ['CustomersList'],
  keepUnusedDataFor: 15,
  baseQuery: baseQueryWithReauth(),
  endpoints: (build) => ({
    getCustomersList: build.query<CustomerListItem[], void>({
      query: () => ({
        url: `/customers-list`,
        method: 'GET',
      }),
      providesTags: () => ['CustomersList'],
    }),
    chooseCustomer: build.mutation<ChooseCustomerResponse, ChooseCustomerRequest>({
      query: (body) => ({
        url: `/auth/choose-customer`,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useGetCustomersListQuery, useChooseCustomerMutation } = customersApi;
